import { useHistory, useParams } from "react-router-dom";
import {
  TournamentBackgroundImage,
  TournamentContent,
  TournamentStateHeader,
  TournamentStateWrapper,
} from "./styled";
import {
  getTournamentState,
  TournamentStateResponse,
} from "../../../api/tournament";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
import TournamentStateInfo from "./components/tournament-info";
import TournamentStateNotice from "./components/tournament-notice";
import TournamentStateItm from "./components/tournamnet-itm";
import TournamentStateSitin from "./components/tournamnet-sitin";
import ImageViewerModal from "../../../components/common/ImageViewerModal";

const TournamentStatePage = () => {
  const { id } = useParams<{ id: string }>();
  const inset = useRecoilValue(insetState);
  const history = useHistory();
  const [data, setData] = useState<TournamentStateResponse>();
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const getData = async () => {
    try {
      const res = await getTournamentState(+id);
      setData(res);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <TournamentStateWrapper
      isApp={inset}
      reservation={data?.tournament.reservation ? true : false}
    >
      <ImageViewerModal
        isOpen={!!selectedImage}
        onClose={() => setSelectedImage(null)}
        imageUrl={selectedImage || ""}
      ></ImageViewerModal>
      <TournamentStateHeader isApp={inset}>
        <div
          className="close"
          onClick={() => {
            history.goBack();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 19L5 12M5 12L12 5M5 12H19"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="title">{data?.tournament.title}</div>
      </TournamentStateHeader>
      {data && (
        <div className="inner">
          {data.tournament.reservation && (
            <TournamentBackgroundImage
              onClick={() => {
                if (data.tournament.reservation)
                  setSelectedImage(data.tournament.reservation.imageUrl);
              }}
            >
              <img src={data.tournament.reservation.imageUrl} alt="img" />
            </TournamentBackgroundImage>
          )}
          <div className="content">
            <TournamentContent
              isReservation={data?.tournament.reservation ? true : false}
            >
              <TournamentStateInfo
                tournament={data.tournament}
                updateData={getData}
              />
              {data.tournament.notice && (
                <TournamentStateNotice notice={data?.tournament.notice} />
              )}
              <TournamentStateItm
                itm={data.itm}
                tournamentType={data.tournament.tournamentType}
                pubType={data.pubType}
              />
              <TournamentStateSitin userList={data.sitInUser} type={"sitin"} />
              <TournamentStateSitin
                userList={data.sitOutUser}
                type={"sitout"}
              />
            </TournamentContent>
          </div>
        </div>
      )}
    </TournamentStateWrapper>
  );
};

export default TournamentStatePage;
